
    <div class="dekstop-detail-score">
        <div id="LiveTV" class="tvol">
            <div class="card-body rada1" #tvIframe cdkDrag>
            </div>
        </div>
    </div>
